/* Petifo Q4 2026 campaign design + signup popup. Built 2026-10-16. Gate: html[data-pf-q4] set in <head>. */
(function () {
  'use strict';
  var KEY = document.documentElement.getAttribute('data-pf-q4');
  if (!KEY) return;
  var dataEl = document.getElementById('pf-q4-data');
  if (!dataEl) return;
  var D;
  try { D = JSON.parse(dataEl.textContent); } catch (e) { return; }
  var C = null;
  for (var i = 0; i < D.c.length; i++) if (D.c[i].key === KEY) C = D.c[i];
  if (!C) return;
  var S = D.s;
  var END = Date.parse(C.end);
  var COLL = D.collectionsUrl + '/' + C.handle;
  var root = document.documentElement;
  root.style.setProperty('--pf-q4-name', JSON.stringify(C.name));

  function ss(k, v) { try { if (v === undefined) return sessionStorage.getItem(k); if (v === null) sessionStorage.removeItem(k); else sessionStorage.setItem(k, v); } catch (e) { return null; } }
  function ls(k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) { return null; } }

  /* ---------- dates & countdown ---------- */
  var loc = (D.locale || 'en');
  if (loc === 'en') loc = 'en-GB';
  function endText() {
    var d = new Date(END - 60000);
    var a, b;
    try {
      a = new Intl.DateTimeFormat(loc, { weekday: 'long', day: 'numeric', month: 'long', timeZone: 'Europe/Berlin' }).format(d);
      b = new Intl.DateTimeFormat(loc, { hour: '2-digit', minute: '2-digit', hourCycle: 'h23', timeZone: 'Europe/Berlin' }).format(d);
    } catch (e) { a = d.toDateString(); b = '23:59'; }
    return a + ', ' + b + ' ' + S.tz;
  }
  var VALID = S.validUntil.replace('__DATE__', endText());
  var VALID_LC = VALID.charAt(0).toLowerCase() + VALID.slice(1);
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function cdText() {
    var ms = END - Date.now();
    if (ms < 0) ms = 0;
    var s = Math.floor(ms / 1000), d = Math.floor(s / 86400); s -= d * 86400;
    var h = Math.floor(s / 3600); s -= h * 3600; var m = Math.floor(s / 60); s -= m * 60;
    return (d > 0 ? d + S.days + ' ' : '') + pad(h) + ':' + pad(m) + ':' + pad(s);
  }
  function tick() {
    var t = cdText();
    var els = document.querySelectorAll('[data-pf-q4-cd]');
    /* Update the existing text node in place: no childList mutation, so the page MutationObserver is not woken every second. */
    for (var j = 0; j < els.length; j++) {
      var tn = els[j].firstChild;
      if (tn && tn.nodeType === 3 && !tn.nextSibling) { if (tn.nodeValue !== t) tn.nodeValue = t; }
      else if (els[j].textContent !== t) els[j].textContent = t;
    }
    if (END - Date.now() <= 0 && !root.hasAttribute('data-pf-q4-preview')) {
      root.removeAttribute('data-pf-q4');
    }
  }
  function fill(scope) {
    var n = scope.querySelectorAll('[data-pf-q4-name-text]');
    for (var j = 0; j < n.length; j++) n[j].textContent = C.name;
    n = scope.querySelectorAll('[data-pf-q4-valid]');
    for (j = 0; j < n.length; j++) n[j].textContent = VALID;
    n = scope.querySelectorAll('[data-pf-q4-valid-lc]');
    for (j = 0; j < n.length; j++) n[j].textContent = VALID_LC;
    n = scope.querySelectorAll('[data-pf-q4-href]');
    for (j = 0; j < n.length; j++) n[j].setAttribute('href', COLL);
    n = scope.querySelectorAll('[data-pf-q4-cd]');
    for (j = 0; j < n.length; j++) n[j].textContent = cdText();
  }
  function fromTpl(id) {
    var t = document.getElementById(id);
    if (!t) return null;
    var el = t.content.firstElementChild.cloneNode(true);
    fill(el);
    return el;
  }

  /* ---------- placements ---------- */
  var main = document.getElementById('MainContent');
  var tpl = (main && main.getAttribute('data-template')) || D.template || '';

  /* Home hero background video per holiday (Higgsfield, 6 s loops; desktop 16:9, mobile 9:16 crop). Added 2026-10-18.
     Files live in Shopify Files (petifo-hero-<key>-desktop|mobile.mp4/.jpg). Reduced motion: poster only. */
  var PF_HV = {"halloween": {"d7": "https://cdn.shopify.com/videos/c/vp/93f8b18f5bf544d3b73e737cd0cbf3e8/93f8b18f5bf544d3b73e737cd0cbf3e8.HD-720p-4.5Mbps-98031435.mp4", "d10": "https://cdn.shopify.com/videos/c/vp/93f8b18f5bf544d3b73e737cd0cbf3e8/93f8b18f5bf544d3b73e737cd0cbf3e8.HD-1080p-7.2Mbps-98031435.mp4", "dp": "https://cdn.shopify.com/s/files/1/1021/4673/6505/files/petifo-hero-halloween-desktop.jpg?width=1600", "m": "https://cdn.shopify.com/videos/c/vp/92d54418f904432eaaa879d07b7c136c/92d54418f904432eaaa879d07b7c136c.HD-1080p-3.3Mbps-98031436.mp4", "mp": "https://cdn.shopify.com/s/files/1/1021/4673/6505/files/petifo-hero-halloween-mobile.jpg?width=700"}, "black-november": {"d7": "https://cdn.shopify.com/videos/c/vp/47279f9d67b041eba5456a0e6dbe0069/47279f9d67b041eba5456a0e6dbe0069.HD-720p-4.5Mbps-98031431.mp4", "d10": "https://cdn.shopify.com/videos/c/vp/47279f9d67b041eba5456a0e6dbe0069/47279f9d67b041eba5456a0e6dbe0069.HD-1080p-7.2Mbps-98031431.mp4", "dp": "https://cdn.shopify.com/s/files/1/1021/4673/6505/files/petifo-hero-black-november-desktop.jpg?width=1600", "m": "https://cdn.shopify.com/videos/c/vp/2dd1d5bae4a84e9b80e6032af571b46e/2dd1d5bae4a84e9b80e6032af571b46e.HD-1080p-3.3Mbps-98031432.mp4", "mp": "https://cdn.shopify.com/s/files/1/1021/4673/6505/files/petifo-hero-black-november-mobile.jpg?width=700"}, "black-friday": {"d7": "https://cdn.shopify.com/videos/c/vp/0f7b5684cac145089a07ca45ebcbfb43/0f7b5684cac145089a07ca45ebcbfb43.HD-720p-4.5Mbps-98031429.mp4", "d10": "https://cdn.shopify.com/videos/c/vp/0f7b5684cac145089a07ca45ebcbfb43/0f7b5684cac145089a07ca45ebcbfb43.HD-1080p-7.2Mbps-98031429.mp4", "dp": "https://cdn.shopify.com/s/files/1/1021/4673/6505/files/petifo-hero-black-friday-desktop.jpg?width=1600", "m": "https://cdn.shopify.com/videos/c/vp/fbe990d3133b4304ad98e3264ebade73/fbe990d3133b4304ad98e3264ebade73.HD-1080p-3.3Mbps-98031430.mp4", "mp": "https://cdn.shopify.com/s/files/1/1021/4673/6505/files/petifo-hero-black-friday-mobile.jpg?width=700"}, "christmas": {"d7": "https://cdn.shopify.com/videos/c/vp/668315cd2d1a44b8946204ecc4921740/668315cd2d1a44b8946204ecc4921740.HD-720p-4.5Mbps-98031433.mp4", "d10": "https://cdn.shopify.com/videos/c/vp/668315cd2d1a44b8946204ecc4921740/668315cd2d1a44b8946204ecc4921740.HD-1080p-7.2Mbps-98031433.mp4", "dp": "https://cdn.shopify.com/s/files/1/1021/4673/6505/files/petifo-hero-christmas-desktop.jpg?width=1600", "m": "https://cdn.shopify.com/videos/c/vp/384400aa16e94239ab444e365d2456a5/384400aa16e94239ab444e365d2456a5.HD-1080p-4.8Mbps-98031434.mp4", "mp": "https://cdn.shopify.com/s/files/1/1021/4673/6505/files/petifo-hero-christmas-mobile.jpg?width=700"}, "new-year": {"d7": "https://cdn.shopify.com/videos/c/vp/dd31d2a28a674528b63a5e216057f3a6/dd31d2a28a674528b63a5e216057f3a6.HD-720p-4.5Mbps-98031437.mp4", "d10": "https://cdn.shopify.com/videos/c/vp/dd31d2a28a674528b63a5e216057f3a6/dd31d2a28a674528b63a5e216057f3a6.HD-1080p-7.2Mbps-98031437.mp4", "dp": "https://cdn.shopify.com/s/files/1/1021/4673/6505/files/petifo-hero-new-year-desktop.jpg?width=1600", "m": "https://cdn.shopify.com/videos/c/vp/6524d48c327b481f936ecd609ea57e07/6524d48c327b481f936ecd609ea57e07.HD-1080p-4.8Mbps-98031439.mp4", "mp": "https://cdn.shopify.com/s/files/1/1021/4673/6505/files/petifo-hero-new-year-mobile.jpg?width=700"}};
  function heroVideo(sec) {
    var hh = sec.querySelectorAll('h2 em, .pf-q4-hero__text');
    for (var q = 0; q < hh.length; q++) hh[q].innerHTML = hh[q].innerHTML.replace(/(\d) (%|kr|€)/g, '$1&nbsp;$2');
    var key = root.getAttribute('data-pf-q4'), v = PF_HV[key];
    if (!v) return;
    var box = sec.querySelector('.pf-q4-hero__media');
    var vid = box && box.querySelector('video');
    if (vid && vid.getAttribute('data-pf-q4-started')) return;
    if (!box) {
      box = document.createElement('div');
      box.className = 'pf-q4-hero__media';
      box.setAttribute('aria-hidden', 'true');
      sec.insertBefore(box, sec.firstChild);
    }
    if (!vid) {
      vid = document.createElement('video');
      vid.setAttribute('disablepictureinpicture', ''); vid.setAttribute('tabindex', '-1');
      box.appendChild(vid);
    }
    vid.setAttribute('data-pf-q4-started', '1');
    vid.muted = true; vid.defaultMuted = true; vid.loop = true; vid.playsInline = true;
    vid.setAttribute('muted', ''); vid.setAttribute('playsinline', ''); vid.setAttribute('preload', 'none');
    sec.classList.add('pf-q4-hero--video');
    var mq = window.matchMedia('(max-width: 899px)');
    var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    /* 2026-11-03 (speed): the poster image is server-rendered and is the LCP element; the video (2-4 MB) starts only
       after the page has loaded and the browser is idle, never above 720p, and not on save-data or 2G/3G. */
    var con = navigator.connection || {};
    if (con.saveData || /(slow-2g|2g|3g)/.test(String(con.effectiveType || ''))) still = true;
    var set = function () {
      var m = mq.matches;
      var src = m ? v.m : v.d7;
      vid.poster = m ? v.mp : v.dp;
      if (still) { vid.removeAttribute('src'); vid.load(); return; }
      if (vid.getAttribute('src') === src) return;
      vid.src = src; vid.autoplay = true;
      vid.addEventListener('playing', function () { vid.classList.add('is-playing'); }, { once: true });
      var p = vid.play(); if (p && p.catch) p.catch(function () {});
    };
    var idle = function (fn) { (window.requestIdleCallback || function (cb) { setTimeout(cb, 1200); })(fn, { timeout: 4000 }); };
    var start = function () { idle(set); };
    if (document.readyState === 'complete') start(); else window.addEventListener('load', start, { once: true });
    if (mq.addEventListener) mq.addEventListener('change', set); else if (mq.addListener) mq.addListener(set);
    /* Decode only while the hero is on screen, so scrolling the cards below stays smooth. */
    if ('IntersectionObserver' in window && !still) {
      new IntersectionObserver(function (en) {
        if (en[0].isIntersecting) { var p2 = vid.play(); if (p2 && p2.catch) p2.catch(function () {}); } else vid.pause();
      }).observe(sec);
    }
    /* The theme's own home hero is hidden during campaigns: stop its video so it does not download or decode. */
    var olds = document.querySelectorAll('#MainContent > .hero-wrapper video');
    for (var o = 0; o < olds.length; o++) { olds[o].pause(); olds[o].preload = 'none'; olds[o].removeAttribute('autoplay'); }
  }
  function ensureHero() {
    if (!main || D.template !== 'index') return;
    var ex = main.querySelector('.pf-q4-hero');
    if (ex) {
      /* Server-rendered hero (snippets/pf-q4-campaign.liquid part 'hero'): reuse it when its key matches. */
      if (ex.getAttribute('data-pf-q4-ssr') === KEY) { fill(ex); heroVideo(ex); return; }
      if (!ex.hasAttribute('data-pf-q4-ssr')) return;
      ex.parentNode.removeChild(ex);
      var exHp = main.querySelector('.pf-q4-hp--ssr'); if (exHp) exHp.parentNode.removeChild(exHp);
    }
    var el = fromTpl('pf-q4-hero-tpl');
    if (el) {
      main.insertBefore(el, main.firstChild);
      heroVideo(el);
      /* Whole hero is clickable to the campaign collection (Peji 2026-10-18); the button stays the keyboard target. */
      var cover = document.createElement('a');
      cover.className = 'pf-q4-hero__link';
      cover.setAttribute('href', COLL);
      cover.setAttribute('tabindex', '-1');
      cover.setAttribute('aria-hidden', 'true');
      el.appendChild(cover);
    }
  }
  function ensureColl() {
    if (!main || D.template !== 'collection' || main.querySelector('.pf-q4-coll')) return;
    if (D.collection !== C.handle && !root.hasAttribute('data-pf-q4-preview')) return;
    var el = fromTpl('pf-q4-coll-tpl');
    if (el) main.insertBefore(el, main.firstChild);
  }
  function buyAnchor() {
    var sels = ['.buy-buttons-block', 'product-form-component', '.product-form-buttons', 'form[action*="/cart/add"]'];
    for (var j = 0; j < sels.length; j++) {
      var el = main && main.querySelector(sels[j]);
      if (el && !el.closest('.pf-qb') && !el.closest('.pf-bundle')) return el;
    }
    return null;
  }
  function ensureNotice() {
    if (!main || !D.eligible || D.template !== 'product' || main.querySelector('[data-pf-q4-notice]')) return;
    var a = buyAnchor();
    if (!a) return;
    var el = fromTpl('pf-q4-notice-tpl');
    if (el) a.parentNode.insertBefore(el, a.nextSibling);
  }
  function ensureQb() {
    var boxes = document.querySelectorAll('.pf-qb');
    for (var j = 0; j < boxes.length; j++) {
      if (boxes[j].querySelector('[data-pf-q4-qbhead]')) continue;
      var el = fromTpl('pf-q4-qbhead-tpl');
      if (el) boxes[j].insertBefore(el, boxes[j].firstChild);
    }
  }
  function ensureCart() {
    var boxes = document.querySelectorAll('.cart-drawer__content');
    for (var j = 0; j < boxes.length; j++) {
      var box = boxes[j];
      if (box.closest('.cart-drawer--empty') || !box.querySelector('.cart-items, .cart-items__table, [class*="cart-item"]')) continue;
      if (box.querySelector('[data-pf-q4-cartbar]')) continue;
      var el = fromTpl('pf-q4-cart-tpl');
      if (!el) continue;
      var timer = box.querySelector('#pf-cart-timer');
      if (timer && timer.parentNode === box) box.insertBefore(el, timer); else box.insertBefore(el, box.firstChild);
    }
  }
  /* Complete the Set bundle: holiday header strip (design only; bundle logic, products and code untouched) */
  function ensureBundle() {
    var boxes = document.querySelectorAll('.pf-bundle');
    for (var j = 0; j < boxes.length; j++) {
      if (boxes[j].querySelector('[data-pf-q4-bhead]')) continue;
      var el = fromTpl('pf-q4-bhead-tpl');
      if (el) boxes[j].insertBefore(el, boxes[j].firstChild);
    }
  }
  /* Home page: campaign products under the hero. Cards come from sections/pf-q4-products.liquid via the
     Section Rendering API on the campaign collection; preview falls back to /collections/sale. */
  /* Section id of templates/collection.pfq4home.json in theme 198224281977. If the theme is duplicated the id
     changes; the full ?view=pfq4home page is then fetched instead (same cards, larger response). */
  var HP_SECTION = 'template--30794608083321__pf_q4_products';
  var hpState = 0;
  function hpGet(url) {
    return fetch(url, { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error(r.status);
      return r.text();
    }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var grid = doc.querySelector('[data-pf-q4-hp-src] .pf-q4-hp__grid');
      if (!grid || !grid.querySelector('.pf-q4-hp__item')) throw new Error('empty');
      return grid;
    });
  }
  function hpLoad(handle) {
    var base = D.collectionsUrl + '/' + handle + '?view=pfq4home';
    return hpGet(base + '&section_id=' + HP_SECTION).catch(function () { return hpGet(base); });
  }
  function ensureHome() {
    if (hpState || !main || D.template !== 'index') return;
    var hero = main.querySelector('.pf-q4-hero');
    if (!hero) return;
    var ssrHp = main.querySelector('.pf-q4-hp--ssr[data-pf-q4-ssr="' + KEY + '"]');
    var el = ssrHp || fromTpl('pf-q4-hp-tpl');
    if (!el) return;
    hpState = 1;
    if (ssrHp) fill(el); else hero.parentNode.insertBefore(el, hero.nextSibling);
    var show = function (grid) {
      var list = el.querySelector('[data-pf-q4-hp-list]');
      list.appendChild(document.importNode(grid, true));
      var hb = el.querySelector('.pf-q4-hp__btn');
      if (hb && !el.querySelector('.pf-q4-hp__more')) {
        var more = document.createElement('div');
        more.className = 'pf-q4-hp__more';
        var b2 = hb.cloneNode(true);
        b2.classList.remove('pf-q4-hp__btn');
        more.appendChild(b2);
        list.parentNode.insertBefore(more, list.nextSibling);
      }
      el.hidden = false;
    };
    hpLoad(C.handle).then(show, function () {
      if (!root.hasAttribute('data-pf-q4-preview')) throw new Error('none');
      return hpLoad('sale').then(show);
    }).catch(function () { if (el.parentNode) el.parentNode.removeChild(el); });
  }
  /* Product page: the same campaign tag as on the product cards, on the main image (Peji 2026-10-18). */
  function ensurePdpChip() {
    if (!main || !D.eligible || D.template !== 'product') return;
    var g = main.querySelector('media-gallery slideshow-container') || main.querySelector('media-gallery');
    if (!g || g.querySelector('.pf-q4-chips--pdp')) return;
    var w = document.createElement('span');
    w.className = 'pf-q4-chips pf-q4-chips--pdp';
    w.setAttribute('aria-hidden', 'true');
    w.innerHTML = '<span class="pf-q4-chip pf-q4-chip--name"></span>';
    if (getComputedStyle(g).position === 'static') g.style.position = 'relative';
    g.appendChild(w);
  }
  function ensureAll() { ensureHero(); ensureHome(); ensureColl(); ensureNotice(); ensurePdpChip(); ensureQb(); ensureCart(); ensureBundle(); }

  /* ---------- popup ---------- */
  var pop = document.querySelector('[data-pf-q4-pop]');
  var teaser = document.querySelector('[data-pf-q4-teaser]');
  var lastFocus = null;
  var K_DONE = 'pf_q4_done_' + KEY, K_SEEN = 'pf_q4_seen_' + KEY, K_TX = 'pf_q4_teaser_x_' + KEY, K_SUB = 'pf_q4_submitting';
  var path = location.pathname;
  var blocked = /\/(cart|account|checkout|checkouts|policies|challenge|password)(\/|$)/.test(path);
  function pct(s) { return s.replace(/__PCT__/g, String(C.extra)); }
  function setupPop() {
    if (!pop) return;
    fill(pop);
    pop.querySelector('[data-pf-q4-pop-title]').textContent = pct(S.popTitle);
    pop.querySelector('[data-pf-q4-extra-big]').textContent = pct(S.extraBig);
    pop.querySelector('[data-pf-q4-done-text]').textContent = pct(S.doneText);
    pop.querySelector('[data-pf-q4-code]').textContent = C.code;
    var shop = pop.querySelector('[data-pf-q4-shop]');
    shop.setAttribute('href', D.root + '/discount/' + encodeURIComponent(C.code) + '?redirect=' + encodeURIComponent(COLL));
    var tags = pop.querySelector('[data-pf-q4-tags]');
    if (tags) tags.value = 'newsletter,q4-' + KEY;
  }
  function showStep(done) {
    pop.querySelector('[data-pf-q4-step="form"]').hidden = !!done;
    pop.querySelector('[data-pf-q4-step="done"]').hidden = !done;
  }
  function teaserText() {
    var t = teaser && teaser.querySelector('[data-pf-q4-teaser-text]');
    if (t) t.textContent = ls(K_DONE) ? S.teaserCode : pct(S.teaser);
  }
  function showTeaser(on) {
    if (!teaser) return;
    teaser.hidden = !on || ss(K_TX) === '1';
  }
  function focusables() {
    return Array.prototype.filter.call(pop.querySelectorAll('a[href],button,input:not([type=hidden]),[tabindex]:not([tabindex="-1"])'), function (el) { return el.offsetParent !== null; });
  }
  function openPop(focusEl) {
    if (!pop || !pop.hidden) return;
    lastFocus = document.activeElement;
    showStep(!!ls(K_DONE));
    pop.hidden = false;
    ss(K_SEEN, '1');
    showTeaser(false);
    document.addEventListener('keydown', onKey, true);
    var f = focusEl || (ls(K_DONE) ? pop.querySelector('[data-pf-q4-copy]') : pop.querySelector('#pf-q4-email'));
    setTimeout(function () { if (f) f.focus(); }, 30);
  }
  function closePop() {
    if (!pop || pop.hidden) return;
    pop.hidden = true;
    document.removeEventListener('keydown', onKey, true);
    teaserText();
    showTeaser(true);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function onKey(e) {
    if (e.key === 'Escape') { e.preventDefault(); closePop(); return; }
    if (e.key === 'Tab') {
      var f = focusables(); if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  }
  function initPop() {
    if (!pop || blocked) return;
    setupPop();
    var close = pop.querySelectorAll('[data-pf-q4-close]');
    for (var j = 0; j < close.length; j++) close[j].addEventListener('click', closePop);
    var form = pop.querySelector('form');
    var input = pop.querySelector('#pf-q4-email');
    var err = pop.querySelector('#pf-q4-err');
    function setErr(msg) { err.textContent = msg || ''; err.hidden = !msg; if (msg) input.setAttribute('aria-invalid', 'true'); else input.removeAttribute('aria-invalid'); }
    input.addEventListener('input', function () { if (!err.hidden) setErr(''); });
    form.addEventListener('submit', function (e) {
      var v = (input.value || '').trim();
      if (!v) { e.preventDefault(); setErr(S.errEmpty); input.focus(); return; }
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v)) { e.preventDefault(); setErr(S.errInvalid); input.focus(); return; }
      input.value = v;
      ss(K_SUB, KEY);
    });
    var copyBtn = pop.querySelector('[data-pf-q4-copy]');
    copyBtn.addEventListener('click', function () {
      var done = function () { copyBtn.textContent = S.copied; pop.querySelector('[data-pf-q4-copied]').textContent = S.copied; setTimeout(function () { copyBtn.textContent = S.copy; }, 2000); };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(C.code).then(done, done);
      else { var r = document.createRange(); r.selectNodeContents(pop.querySelector('[data-pf-q4-code]')); var sel = getSelection(); sel.removeAllRanges(); sel.addRange(r); try { document.execCommand('copy'); } catch (x) {} done(); }
    });
    if (teaser) {
      teaser.querySelector('[data-pf-q4-reopen]').addEventListener('click', function () { openPop(); });
      teaser.querySelector('[data-pf-q4-teaser-x]').addEventListener('click', function () { ss(K_TX, '1'); teaser.hidden = true; });
    }
    /* Returning from the native customer form post */
    var params = new URLSearchParams(location.search);
    if (ss(K_SUB) === KEY) {
      ss(K_SUB, null);
      if (params.get('customer_posted') === 'true') { ls(K_DONE, '1'); openPop(); return; }
      if (pop.querySelector('[data-pf-q4-server-error]')) { openPop(); setErr(S.errServer); return; }
    }
    teaserText();
    if (ss(K_SEEN) === '1') { showTeaser(true); return; }
    var timer;
    var autoOpen = function () {
      if (document.querySelector('dialog[open]') || ss(K_SEEN) === '1') { if (ss(K_SEEN) !== '1') timer = setTimeout(autoOpen, 4000); return; }
      openPop();
    };
    timer = setTimeout(autoOpen, 6000);
    var onLeave = function (e) { if (!e.relatedTarget && e.clientY <= 0) { clearTimeout(timer); document.removeEventListener('mouseout', onLeave); autoOpen(); } };
    if (window.matchMedia && matchMedia('(hover:hover) and (pointer:fine)').matches) document.addEventListener('mouseout', onLeave);
  }

  /* ---------- boot ---------- */
  function boot() {
    fill(document.querySelector('[data-pf-q4-bar]') || document.createElement('div'));
    ensureAll();
    initPop();
    tick();
    setInterval(tick, 1000);
    var pending = false;
    var mo = new MutationObserver(function (list) {
      if (pending) return;
      /* Only react when real nodes were added outside our own campaign blocks (cards, drawers, sections). */
      var real = false;
      for (var k = 0; k < list.length && !real; k++) {
        var tg = list[k].target;
        if (!list[k].addedNodes.length) continue;
        if (tg.nodeType === 1 && tg.closest && tg.closest('[data-pf-q4-cd],.pf-q4-hero,.pf-q4-bar')) continue;
        real = true;
      }
      if (!real) return;
      pending = true;
      setTimeout(function () { pending = false; ensureAll(); }, 120);
    });
    mo.observe(document.body, { childList: true, subtree: true });
    document.addEventListener('cart:update', function () { setTimeout(ensureCart, 50); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
